import styled from "styled-components";

export const ControllerHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ControllerHeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 30px;
  color: #fff;

  > .title {
    font-weight: 900;
    font-size: 50px;
  }

  input {
    display: none;
  }
`;

export const ControllerHeaderButtonWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  > .button {
    cursor: pointer;
    width: 195px;
    height: 72px;
    border-radius: 15px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 25px;
    line-height: 72px;
    text-align: center;
    color: #fff;

    &.gray {
      background: #969696;
    }

    &.end {
      color: #969696;
    }

    &.green {
      background: #35c31e;
    }
  }
`;
